import qs from 'qs';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { clientConfig } from '../../config/client';
import localStorage from '../../core/local-storage/localStorage';

// TODO add message for logout reason
class Logout extends React.Component<any> {
  public componentDidMount(): void {
    const { location } = this.props;

    this.props.dispatch({
      type: 'USER:INITIAL',
    });

    const { redirect } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    localStorage.remove(clientConfig.tokenParamName);
    localStorage.remove('X-Intranet-Token');
    localStorage.remove('admin-toolbar-settings');
    window.location.replace(`/${redirect || ''}`);
  }

  public render() {
    return null;
  }
}

export default connect()(withRouter(Logout));
